export default __webpack_public_path__ + "static/media/3.c116e989.png";